// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fdc7b59b","455":"afc5bf4b","977":"ac60ccea"}[chunkId] + ".chunk.js";
};